export interface CodeDescriptionError {
    code: string;
    description: IErrorDescription;
    internalErrors: string[];
    showModal: boolean;
}

export interface Notifica<TPayload, TScelta> {
    id: string;
    data: string | Date;
    annoRiferimento: number;
    dataUltimoInvio?: string | Date;
    tipo: TipoNotificaUtente;
    titolo: string;
    messaggio: string;
    messaggioBreve: string;
    trasparente: boolean;
    priorita: number;
    gestita: boolean;
    annullata: boolean;
    gestitaIl: string;
    sceltaGestioneIndirizzoIp: string;
    riferimentoId: string;
    utentiId?: number;
    payload?: TPayload;
    sceltaGestione?: TScelta;

    codiceFirmaLength?: number;

    staticData?: any;
}

export interface ContainerSasUri {
    url: string;
    sasKey: string;
}

export class NotificaUtente<TPayload = any, TScelta = any> implements Notifica<TPayload, TScelta> {
    id: string;
    data: string | Date;
    annoRiferimento: number;
    dataUltimoInvio?: string | Date;
    tipo: TipoNotificaUtente;
    titolo: string;
    messaggio: string;
    messaggioBreve: string;
    trasparente: boolean;
    priorita: number;
    gestita: boolean;
    annullata: boolean;
    gestitaIl: string;
    sceltaGestioneIndirizzoIp: string;
    riferimentoId: string;
    idUtente?: number;
    payload?: TPayload;
    sceltaGestione?: TScelta;
    codiceFirmaLength?: number;
    staticData?: any;

    constructor(init?: Partial<Notifica<TPayload, TScelta>>) {
        Object.assign(this, init);
    }

    get isInAttesa() {
        return this.gestita === false && this.annullata === false && !!this.data;
    }

    get isAnnullata() {
        return this.annullata === true && this.gestita === false && !!this.data;
    }

    get isGestita() {
        return this.gestita === true && !!this.data;
    }
}

export interface IErrorDescription {
    exception: string;
    message: string;
}

export type JobState = 'Enqueued' | 'Processing' | 'Succeeded' | 'Failed' | 'Completed' | 'Awaiting';

export interface JobData {
    jobId: string;
    args: any[];
    name: string;
    createdAt: Date;
    state: JobState;
    jobStateName: string;
    reason: any;
    data: Data;
}

export interface Data {
    succeededAt: Date;
    performanceDuration: string;
    latency: string;
}

export enum TipoNotificaUtente {
    Annullata = -1,
    Informazione = 0,
    AvvisoPagamentoScadenza = 1,
    NotificaEsitoPagamentoF24 = 2,
    NotificaSceltaRate = 5,
    NotificaRispostaTicket = 6,
    EmailRegistrazioneConfermata = 7,
    PagamentoScadenzaGestito = 8,
    NotificaFattureDaIncassare = 9,
    NotificaDichiarazioneChiusa = 10,
    NotificaRichiestaDocumentoIdentita = 11,
    NotificaPecDocumentiAgenziaEntrate = 12,
    NotificaAcquisizioneDatiInps = 13,
    NotificaAttivazioneCassettoFiscale = 14,
    NotificaInstrastatCreata = 15,
    NotificaPreliminareDichiarazioneUtente = 16,
    NotificaFondo2020 = 17,
    NotificaAbbonamentoInScadenza = 18,
    NotificaAbbonamentoScaduto = 19,
    NotificaPecSceltaPagamento = 20,
    NotificaAccontoDiNovembre = 21,
    NotificaSecondoAccontoGennaio = 22,
    NotificaAccontoDiNovembreRicalcoloNonPossibile = 23,
    NotificaCovidAccontoDiNovembreRinviatoZonaRossa = 24,
    NotificaCovidAccontoDiNovembreRinviatoCaloFatturato = 25,
    NotificaCovidAccontoDiNovembreRinviatoDicembre = 26,
    NotificaContrattoPostAbbonamento = 27,
    AffiliazioneInvito = 28,
    NotificaFirmaUnico = 30,
    NotificaDichiarazioneEsterna = 31,
    NotificaEmissioneDaImportareOrAltraContribuzione = 32,
    NotificaCambiamentoScadenzeRateDichiarazioni = 60,
    NotificaRiduzioneTerminiAccertamento = 61,
    NotificaDichiarazioneQuadroRs = 62,
    NotificaPrecompilataAltriRedditi = 63,
    NotificaDichiarazioneRiepilogoAndPagamento = 64,
    NotificaSgravioContribuzione = 33,
    RinnovaForfettTestaci = 34,
    NotificaSgravioFirmato = 35,
    NotificaDelegheMancanti = 36,
    ConvenzioneIban = 37,
    NotificaRateizzazioneInail = 38,
    NotificaSuperamentoLimiteRegimeForfettario = 39,
    NotificaDichiarazioneTardiva = 40,
    NotificaStatoSDIFatturaAttiva = 3,
    NotificaRicezioneFatturaPassivaSDI = 4,
    NotificaAggiornamentoStatoSDIAutofattura = 45,
    NotificaFattureDaInviareSdi = 46,
    NotificaFattureNonInviateNeiTerminiSdi = 47,
    NotificaGestioneFattureAttiveImportate = 48,
    NotificaEnasarco = 50,
    NotificaFirmaDocumento = 70,
    NotificaGestioneConcordato = 80,
    NotificaScaricoPreliminarePrecompilata = 100,
}

export enum BlobStorageErrorCode {
    AutenticazioneScaduta = 403,
    ElementoNonTrovato = 404,
}

export enum ErrorHandlingMode {
    useGlobalErrorHandler,
    useLocalErrorHandler,
}
export enum LoaderHandlingMode {
    useGlobalLoaderHandler,
    useLocalLoaderHandler,
}

export interface ModelState {
    [index: string]: string[];
}
